import { render, staticRenderFns } from "./ConversationPreview.vue?vue&type=template&id=5ba81424&scoped=true&"
import script from "./ConversationPreview.vue?vue&type=script&lang=js&"
export * from "./ConversationPreview.vue?vue&type=script&lang=js&"
import style0 from "./ConversationPreview.vue?vue&type=style&index=0&id=5ba81424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba81424",
  null
  
)

export default component.exports